<div>
  <kl-cooperative-society-edit (closeDialog)="ok()"></kl-cooperative-society-edit>
</div>
